function setMaxHeight() {
  const html = document.querySelector('html');
  const app = document.getElementById('app');
  app.style.height = '100%';
  html.style.height = '100%';
}

function getShowContentsHeight() {
  let showContents = document.getElementById('js-show-contents');
  return showContents.clientHeight;
}

function setTranslate(scrollHeight) {
  // console.log(scrollHeight);
  let translate = document.getElementById('js-note-audio');
  translate.style.transform = 'translateY(' + scrollHeight + 'px)';
}

function getWindowHeight() {
  return window.innerHeight;
}

function setScrollPosition() {
  let scrollHeight = getScrollHeight();
  setTranslate(scrollHeight);
}

function getScrollHeight() {
  let noteContents = document.getElementById('js-note-contents');
  let wh = getWindowHeight();
  return wh - (getShowContentsHeight() + noteContents.clientHeight + 16);
}

function initializedScroll() {
  setMaxHeight();
  let notes = document.getElementById('notes');
  let noteAudio = document.getElementById('js-note-audio');
  let audioContents = document.getElementById('js-audio-contents');

  notes.style.paddingBottom = audioContents.clientHeight + 'px';
  noteAudio.style.top = getWindowHeight() - audioContents.clientHeight + 'px';

  chapterMaxHeight();
}

function toggleContents(status) {
  let noteAudio = document.getElementById('js-note-audio');
  let audioContents = document.getElementById('js-audio-contents');

  let height = getWindowHeight() - audioContents.clientHeight;
  if(status) {
    noteAudio.style.transform = 'translateY(0)';
  } else {
    noteAudio.style.transform = 'translateY(-' + height + 'px)';
  }
}

function chapterMaxHeight() {
  // 画面高さ - 'js-audio-contents'の高さ - 'js-note-audio'のpadding-bottom
  let audioContents = document.getElementById('js-audio-contents');
  let setMaxHeight = getWindowHeight() - audioContents.clientHeight - '56';
  let chapter = document.getElementById('js-chapter');
  chapter.style.maxHeight = setMaxHeight + 'px';
}

export default {
  setMaxHeight,
  getShowContentsHeight,
  setTranslate,
  getWindowHeight,
  setScrollPosition,
  getScrollHeight,

  initializedScroll,
  toggleContents,
  chapterMaxHeight
}



// WEBPACK FOOTER //
// ./src/model/notes/height.js